import { Outlet } from 'react-router-dom'

import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'
import { TrainingClassFragment, TrainingDetailFragment } from 'generated/resources/graphql'

import { useBulkAction } from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useBulkActionsConfig'
import { useColumns } from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useColumns'
import { useDataSource } from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useDataSource'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

const ParticipantsOneDataTable = ({
  training,
  trainingClasses,
  outletContext,
}: {
  training: TrainingDetailFragment
  trainingClasses: TrainingClassFragment[]
  outletContext: DetailOutletContext
}) => {
  const source = useDataSource(training, trainingClasses)
  const columns = useColumns()
  const handleBulkAction = useBulkAction(trainingClasses)

  return (
    <>
      <OneDataCollection
        source={source}
        onBulkAction={handleBulkAction}
        visualizations={[
          {
            type: 'table',
            options: {
              frozenColumns: 1,
              columns,
            },
          },
        ]}
      />
      <Outlet context={outletContext} />
    </>
  )
}

export default ParticipantsOneDataTable
